import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';

import { GLOBAL_IMPACT_PATH } from '../../router/paths';

type Props = RouteComponentProps;

class HomeScene extends React.PureComponent<Props> {
    componentDidMount(): void {
        const { history } = this.props;

        history.replace(GLOBAL_IMPACT_PATH);
    }

    render() {
        return null;
    }
}

export default withRouter(HomeScene);
